import { GeneralStyle } from '@website-builder/model/style/general-style';

export class SliderStyle extends GeneralStyle {
  static normalize(styles: Partial<SliderStyle>): SliderStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const accordionStyle = new SliderStyle();

    Object.assign(accordionStyle, generalStyle);

    return accordionStyle;
  }
}
